// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__UIED4","employee-header-item":"Header_employee-header-item__-XriO"};